"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * # Background Colors
 * Background colors should be used only for backgrounds of higher level sections & containers of a UI.
 *
 * @colorSet verbose
 */
var backgroundColors = {
  backgroundColorPopup: '#ffffff',
  backgroundColorSection: '#ffffff',
  backgroundColorSidebar: '#f8f8f8',
  backgroundColorPage: '#f9f9f9',
  backgroundColorNavigation: '#f7f7f7',
  backgroundColorFloating: '#000000',
  backgroundColorDialog: '#ffffff',
  backgroundColorScrim: 'rgba(255, 255, 255, 0.75)'
};
/**
 * # Content Colors
 * Content colors should be used for text, icons and dividers.
 *
 * @colorSet verbose
 */

var contentColors = {
  contentColorActive: '#2c2c2c',
  contentColorDefault: '#4d4d4d',
  contentColorDisabled: '#878787',
  contentColorInverted: '#ffffff',
  contentColorMuted: '#6b6b6b'
};
/**
 * # Interactive Colors
 * Interactive colors are specifically chosen for borders and backgrounds of controls and other interactive content.
 * "Overlay" colors are intended to be placed over the default background color, such as interactiveColorPrimary.
 * If the default background color is not transparent, the `blend` mixin can be used to create a new color that combines the two.
 *
 * @colorSet verbose
 */

var interactiveColors = {
  interactiveColorPrimary: '#0264d7',
  interactiveColorBorder: 'rgba(0, 0, 0, 0.4)',
  interactiveColorBorderHover: 'rgba(0, 0, 0, 0.6)',
  interactiveColorBorderDisabled: 'rgba(0, 0, 0, 0.3)',
  interactiveColorOverlaySelected: 'rgba(0, 0, 0, 0.04)',
  interactiveColorOverlayHover: 'rgba(0, 0, 0, 0.03)',
  interactiveColorOverlayActive: 'rgba(0, 0, 0, 0.07)',
  interactiveColorOverlayDrag: 'rgba(2, 100, 215, 0.16)',
  interactiveColorBackground: '#eeeeee',
  interactiveColorBackgroundDisabled: 'rgba(0, 0, 0, 0.1)'
};
/**
 * # Neutral Colors
 * Neutrals are used for dividers and as backup colors that can sparingly be used for cases, when the other defined colors are not enough.
 *
 * @colorSet verbose
 */

var neutralColors = {
  white: '#ffffff',
  neutral100: '#f0f0f0',
  neutral200: '#e6e6e6',
  neutral300: '#dddddd',
  neutral400: '#cacaca',
  neutral500: '#b8b8b8',
  black: '#000000'
};
/**
 * # Accent Colors
 * Accent colors aid and categorize the visual communication of the system response.
 *
 * @colorSet verbose
 */

var accentColors = {
  accentColorPositive: '#118832',
  accentColorWarning: '#cca700',
  accentColorAlert: '#cf750c',
  accentColorNegative: '#d41f1f'
};
/**
 * # Status Colors
 * Status colors are reserved for communicating urgency and severity associated with data objects.
 *
 * @colorSet verbose
 */

var statusColors = {
  statusColorInfo: '#61cafa',
  statusColorNormal: '#85eb48',
  statusColorLow: '#fae75f',
  statusColorMedium: '#f5b53f',
  statusColorHigh: '#ec4B43',
  statusColorCritical: '#9c0300'
};
/**
 * # Elevation Shadows
 *
 * @shadowSet
 *
 */

var elevationShadows = {
  embossShadow: ' 0px 1px 5px rgba(0, 0, 0, 0.07), 0px 0px 1px rgba(0, 0, 0, 0.07)',
  overlayShadow: '0px 26px 103px rgba(0, 0, 0, 0.13), 0px 11px 18px rgba(0, 0, 0, 0.06), 0px 3px 6px rgba(0, 0, 0, 0.06)',
  dragShadow: '0px 26px 103px rgba(0, 0, 0, 0.13), 0px 11px 18px rgba(0, 0, 0, 0.06), 0px 3px 6px rgba(0, 0, 0, 0.06)',
  modalShadow: '0px 50px 200px rgba(0, 0, 0, 0.3), 0px 29px 66px rgba(0, 0, 0, 0.08), 0px 29px 47px rgba(0, 0, 0, 0.08), 0px 5px 10px rgba(0, 0, 0, 0.03)'
};
/**
 * # Syntax Colors
 * Syntax colors are used only for code blocks.
 *
 * @colorSet verbose alphabetical
 */

var syntaxColors = {
  syntaxBlue: '#107d9f',
  syntaxBrown: '#a26604',
  syntaxGray: '#737373',
  syntaxGreen: '#607d0d',
  syntaxOrange: '#b75808',
  syntaxPink: '#d015b2',
  syntaxPurple: '#7f52f5',
  syntaxRed: '#df1f48',
  syntaxTeal: '#1e816f'
};

var theme = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, accentColors), statusColors), elevationShadows), backgroundColors), contentColors), neutralColors), interactiveColors), syntaxColors);

var _default = theme;
exports["default"] = _default;